import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, Stack, Alert } from '@mui/material';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';

const PaymentFailed: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);

    const orderId = params.get('order_id') || params.get('orderId') || params.get('id');
    const statusMessage = params.get('status_message') || params.get('message') || 'Pembayaran tidak berhasil';

    const [bookingDetails, setBookingDetails] = useState<any>(null);
    const [previousBookingPath, setPreviousBookingPath] = useState<string | null>(null);
    const [isJerseyOrder, setIsJerseyOrder] = useState<boolean>(false);

    useEffect(() => {
        const fetchBookingDetails = async () => {
            if (!orderId) return;
            try {
                const response = await axios.get(`${API_ENDPOINTS.BOOKINGS}?action=booking-details&order_id=${encodeURIComponent(orderId)}`);
                if (response.data?.success) {
                    // Check if this is a jersey order
                    if (response.data.booking?.type === 'jersey' || response.data?.type === 'jersey') {
                        setIsJerseyOrder(true);
                    }
                    setBookingDetails(response.data.booking || response.data);
                }
            } catch (error) {
                console.error('Error fetching booking details for payment failed page:', error);
            }
        };

        fetchBookingDetails();
    }, [orderId]);

    useEffect(() => {
        const fetchPreviousBookingPath = async () => {
            const tempatName = bookingDetails?.booking?.tempat || bookingDetails?.tempat;
            if (!tempatName) return;
            try {
                const [gorResponse, coachingResponse] = await Promise.all([
                    axios.get(API_ENDPOINTS.GOR),
                    axios.get('/api/coaching')
                ]);
                const gorList = gorResponse.data || [];
                const coachingList = coachingResponse.data || [];

                const foundCoaching = coachingList.find((item: any) =>
                    item.id === tempatName ||
                    item.nama === tempatName ||
                    item.nama?.toLowerCase() === tempatName?.toLowerCase()
                );
                if (foundCoaching) {
                    setPreviousBookingPath(`/coaching/${foundCoaching.id}`);
                    return;
                }

                const foundGor = gorList.find((gor: any) =>
                    gor.id === tempatName ||
                    gor.nama === tempatName ||
                    gor.nama?.toLowerCase() === tempatName?.toLowerCase()
                );
                if (foundGor) {
                    setPreviousBookingPath(`/gor/${foundGor.id}`);
                }
            } catch (error) {
                console.error('Error fetching previous booking route for payment failed page:', error);
            }
        };

        fetchPreviousBookingPath();
    }, [bookingDetails]);

    return (
        <Container maxWidth="sm" sx={{ py: 6 }}>
            <Box sx={{ mt: 4, p: 4, borderRadius: 3, backgroundColor: 'background.paper', boxShadow: 3 }}>
                <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
                    Pembayaran Gagal
                </Typography>

                <Alert severity="error" sx={{ mb: 3 }}>
                    Terjadi masalah saat proses pembayaran. Silakan coba lagi atau hubungi admin jika perlu.
                </Alert>

                {orderId && (
                    <Typography variant="body1" sx={{ mb: 1 }}>
                        Order ID: <strong>{orderId}</strong>
                    </Typography>
                )}
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Pesan: <strong>{statusMessage}</strong>
                </Typography>

                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" sx={{ mt: 3 }}>
                    {isJerseyOrder ? (
                        <>
                            <Button variant="contained" onClick={() => navigate('/jersey')}>Kembali ke Halaman Jersey</Button>
                            <Button variant="outlined" onClick={() => navigate('/')}>Kembali ke Beranda</Button>
                        </>
                    ) : (
                        <>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (previousBookingPath) {
                                        navigate(previousBookingPath);
                                    } else {
                                        navigate('/');
                                    }
                                }}
                            >
                                Kembali ke Booking Sebelumnya
                            </Button>
                            <Button variant="outlined" onClick={() => navigate('/')}>Kembali ke Beranda</Button>
                            <Button variant="outlined" onClick={() => navigate('/member')}>Booking Member</Button>
                        </>
                    )}
                </Stack>
            </Box>
        </Container>
    );
};

export default PaymentFailed;
